export class FilterModel {
    id: number;
    departamentItemCode: string;
    entity_code: number;
    year: number;
    version: number;
    type_id: number;
    employee_code: number;
    itemCode: string;
  }
  